// BL-2078 — which RHF errors are the schema's own leaves (not the root banner,
// not a server refusal). Internal to the form hooks; not on the `@auctogon/ui/web` barrel.

import type { FieldErrors } from 'react-hook-form';

/**
 * The dotted paths of every leaf field error the schema raised — never the
 * root banner, never a server refusal (BUG-1688: those stand until the next save).
 * @param errors - RHF's nested error tree, or one branch of it.
 * @param prefix - The branch's path.
 * @returns The paths, e.g. `registrationRequirements.licenseEmail`.
 */
export function clientErrorPaths(errors: FieldErrors | undefined, prefix = ''): string[] {
  return Object.entries(errors ?? {}).flatMap(([key, error]: [string, unknown]) => {
    if (error == null || typeof error !== 'object' || (prefix === '' && key === 'root')) return [];
    const path = prefix === '' ? key : `${prefix}.${key}`;
    const type = (error as { type?: unknown }).type;
    if (typeof type === 'string') return type === 'server' ? [] : [path];
    return clientErrorPaths(error as FieldErrors, path); // a branch: a nested group or a field array
  });
}
